import { Fragment } from 'react';

import { Button } from 'primereact/button';

import { TenantClientService as Service } from './TenantClientService';
import { MGateWayService } from '../../lich-su-truyen-nhan/MGateWayService';

import { ToastService } from '../../../AppToast';

import { useToolbar } from '../../../shared/hooks/Toolbar';
import { useDataTable } from '../../../shared/hooks/DataTable';
import { useDialogCrup } from '../../../shared/hooks/DialogCrup';
import { useImExExcel } from '../../../shared/hooks/ImExExcel';
import { AppStorage } from '../../../service/UserStorage';
import { SearchCMNDService } from '../../../service/SearchCMND';
export const List = () => {

  const header = 'Khách hàng';
  const dataKey = 'id';

  const { render: renderDataTable, refreshLazyData, reloadLazyData, selectedItems, dataTableParams, items } = useDataTable({
    header,
    dataKey,
    columns: [
      { field: 'code', header: 'Mã khách hàng', width: 160, matchMode: 'contains' },
      { field: 'name', header: 'Tên đơn vị', minWidth: 220, matchMode: 'contains' },
      { field: 'taxCode', header: 'Mã số thuế', width: 160, matchMode: 'contains' },
      { field: 'personContact', header: 'Người mua hàng', width: 160, matchMode: 'contains' },
      { field: 'buyerIdentityCard', header: 'CCCD', width: 160, matchMode: 'contains' },
      { field: 'buyerBudgetUnitCode', header: 'Mã đơn vị quan hệ ngân sách', width: 230, matchMode: 'contains' },
      { field: 'address', header: 'Địa chỉ', minWidth: 160, matchMode: 'contains' },
      { field: 'mobile', header: 'Điện thoại', width: 160, matchMode: 'contains' },
      { field: 'email', header: 'Email', width: 160, matchMode: 'contains' },
      { field: 'bankAccount', header: 'Số tài khoản', width: 160, matchMode: 'contains' },
      { field: 'bankName', header: 'Tên ngân hàng', width: 160, matchMode: 'contains' },
      { field: 'hasAccount', header: 'Đã tạo tài khoản', width: 180, matchMode: 'equals', filterType: 'boolean', dataType: 'boolean' },
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      return Service.getList(params);
    }
  });

  const searchTaxCode = () => {
    const { taxCode, code } = getValue();

    const validateTaxCode = (value) => {
      let patt = /^[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]$/;
      if (value.length > 10) {
        patt = /^[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][-][0-9][0-9][0-9]$/;
      }
      const cccdRegex = /^[0-9]{3}[0-5]\d{2}\d{6}$/;
      if (value === "") return true;

      // Kiểm tra nếu là căn cước công dân (12 ký tự)
      if (value.length === 12) {
        return cccdRegex.test(value);
      }

      // Kiểm tra mã số thuế
      if (patt.test(value) === false) {
        return false;
      }
      const number = Number(value.charAt(0)) * 31 + Number(value.charAt(1)) * 29 + Number(value.charAt(2)) * 23
        + Number(value.charAt(3)) * 19 + Number(value.charAt(4)) * 17 + Number(value.charAt(5)) * 13
        + Number(value.charAt(6)) * 7 + Number(value.charAt(7)) * 5 + Number(value.charAt(8)) * 3;

      return (10 - number % 11) === Number(value.charAt(9));
    };

    const isValidTaxCode = validateTaxCode(taxCode);

    if (taxCode.length === 12 && isValidTaxCode) {
      SearchCMNDService.get(taxCode).then(data => {

        if (data) {
          if (data.error) {
            ToastService.error(data.error);
          } else if (data.ho_ten) {
            setValue({
              code: code || '',
              taxCode: taxCode || '',
              name: data.ho_ten || '',
            });
          } else {
            ToastService.error('Không tìm thấy dữ liệu CCCD.');
          }
        } else {
          MGateWayService.searchTaxCodeV2(taxCode).then(data => {
            if (data) {
              setValue({
                code: code || '',
                taxCode: data.buyerTaxCode || '',
                name: data.buyerLegalName || '',
                personContact: data.buyerDisplayName || '',
                address: data.buyerAddress || ''
              });
            }
          }).catch(error => {
            ToastService.error('Lỗi khi tìm kiếm CCCD.');
          });
        }
      }).catch(error => {
        MGateWayService.searchTaxCodeV2(taxCode).then(v2Data => {
          if (v2Data) {
            setValue({
              code: code || '',
              taxCode: v2Data.buyerTaxCode || '',
              name: v2Data.buyerLegalName || '',
              personContact: v2Data.buyerDisplayName || '',
              address: v2Data.buyerAddress || ''
            });
          } else {
            ToastService.error('Không tìm thấy dữ liệu');
          }
        }).catch(v2Error => {
          ToastService.error('Lỗi khi tìm kiếm CCCD.');
        });
      });
    } else if (isValidTaxCode) {
      // Gọi searchTaxCode (V1) trước
      MGateWayService.searchTaxCode(taxCode).then(data => {
        if (data) {
          const provinceName = data.dctstinhten ?
            (data.dctstinhten.includes('TP') ? data.dctstinhten.replace('TP', 'Thành phố') : `Tỉnh ${data.dctstinhten}`) : '';

          setValue({
            code: code || '',
            taxCode: data.mst || '',
            name: data.tennnt || '',
            personContact: data.buyerDisplayName || '',
            address: `${data.dctsdchi}, ${data.dctsxaten}, ${provinceName}, Việt Nam` || ''
          });
        } else {
          // Nếu V1 không có dữ liệu, thử V2
          MGateWayService.searchTaxCodeV2(taxCode).then(v2Data => {
            if (v2Data) {
              setValue({
                code: code || '',
                taxCode: v2Data.buyerTaxCode || '',
                name: v2Data.buyerLegalName || '',
                personContact: v2Data.buyerDisplayName || '',
                address: v2Data.buyerAddress || ''
              });
            } else {
              ToastService.error('Không tìm thấy dữ liệu');
            }
          }).catch(v2Error => {
            ToastService.error('Lỗi khi tìm kiếm MST (V2).');
          });
        }
      }).catch(v1Error => {
        // Nếu V1 lỗi, thử V2
        MGateWayService.searchTaxCodeV2(taxCode).then(v2Data => {
          if (v2Data) {
            setValue({
              code: code || '',
              taxCode: v2Data.buyerTaxCode || '',
              name: v2Data.buyerLegalName || '',
              personContact: v2Data.buyerDisplayName || '',
              address: v2Data.buyerAddress || ''
            });
          } else {
            ToastService.error('Không tìm thấy dữ liệu');
          }
        }).catch(v2Error => {
          ToastService.error('Lỗi khi tìm kiếm MST.');
        });
      });
    }
  }

  const { render: renderDialogCrup, create, update, clone, getValue, setValue } = useDialogCrup({
    header,
    dataKey,
    width: '60rem',
    fields: [
      { field: 'code', header: 'Mã khách hàng', required: true, uppercase: true, InputTextProps: { maxLength: 50 }, className: 'md:col-6' },
      { field: 'taxCode', header: 'Mã số thuế', InputTextProps: { maxLength: 14, validator: 'taxCode' }, className: 'md:col-5' },
      {
        type: 'custom', className: 'md:col-1', body: (
          <div className="mt-4">
            <Button icon="pi pi-search" className="p-button-rounded p-button-outlined" onClick={searchTaxCode} />
          </div>
        )
      },
      { field: 'name', header: 'Tên đơn vị', InputTextProps: { maxLength: 400 }, className: 'md:col-12' },
      { field: 'personContact', header: 'Người mua hàng', InputTextProps: { maxLength: 100 }, className: 'md:col-4' },
      { field: 'buyerIdentityCard', header: 'CCCD', InputTextProps: { maxLength: 12 }, className: 'md:col-4' },
      { field: 'buyerBudgetUnitCode', header: 'Mã đơn vị quan hệ ngân sách', InputTextProps: { maxLength: 7 }, className: 'md:col-4' },
      { field: 'address', header: 'Địa chỉ', InputTextProps: { maxLength: 400 }, className: 'md:col-12' },
      { field: 'email', header: 'Email', InputTextProps: { maxLength: 250, placeholder: 'Email găn cách bởi dấu , hoặc ; ' }, className: 'md:col-6' },
      { field: 'mobile', header: 'Điện thoại', InputTextProps: { maxLength: 20 }, className: 'md:col-6' },
      { field: 'bankAccount', header: 'Số tài khoản', InputTextProps: { maxLength: 30 }, className: 'md:col-5' },
      { field: 'bankName', header: 'Tên ngân hàng', InputTextProps: { maxLength: 400 }, className: 'md:col-7' }
    ],
    createItem: (item) => {
      return Service.create(item);
    },
    updateItem: (id, item) => {
      return Service.update(id, item);
    },
    refreshLazyData
  });

  const { render: renderDialogCrupUser, update: crupUser } = useDialogCrup({
    header: '!Tạo tài khoản tra cứu hóa đơn',
    dataKey,
    width: '45rem',
    fields: [
      { field: 'name', header: 'Tên khách hàng', disabled: true, className: 'md:col-12' },
      { field: 'taxCode', header: 'Mã số thuế', disabled: true, className: 'md:col-12' },
      { field: 'code', header: 'Mã khách hàng', disabled: true, className: 'md:col-12' },
      { field: 'userName', header: 'Tên truy cập', className: 'md:col-12' },
      { field: 'password', header: 'Mật khẩu', type: "Password", InputTextProps: { maxLength: 400 }, className: 'md:col-12' },
      { field: 'email', header: 'Email', InputTextProps: { maxLength: 400 }, className: 'md:col-12' }
    ],
    updateItem: (id, item) => {

      if (item.hasAccount === true) {
        ToastService.error('Chưa chọn khách hàng');
        return;
      }
      let accountInfo = {
        id,
        taxCode: AppStorage.get('tenantName'),
        customerCode: item.code,
        userName: item.userName,
        password: item.password,
        email: item.email,
        appVersion: 2,
      };
      return Service.createAcccountSearch(accountInfo);
    },
    refreshLazyData
  });

  const { renderImExExcel, download, showImportDialog } = useImExExcel({
    exportTemplate: () => {
      return Service.downloadExcelTemplate();
    },
    exportExcel: (params) => {
      return Service.downloadExcel(params);
    },
    exportExcelFileName: 'danh-muc-khach-hang',
    importExcel: (data) => {
      return Service.uploadExcel(data);
    },
    reloadLazyData
  });

  const showCrupUser = () => {
    if (selectedItems?.['id']) {
      crupUser(selectedItems);
    } else {
      ToastService.error('Chưa chọn khách hàng');
    }
  }

  const { renderToolbar } = useToolbar({
    dataKey, create, update, clone, reloadLazyData, selectedItems,
    showImportDialog,
    exportExcel: download, dataTableParams,
    deleteItem: (id) => {
      return Service.delete(id);
    },
    otherActions: [
      {
        label: 'Tạo User tra cứu', icon: 'pi pi-fw pi-user', className: 'iam-toolbar iam-toolbar-help', command: showCrupUser
      }
    ]
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderDialogCrup()}
      {renderDialogCrupUser()}
      {renderImExExcel()}
    </Fragment>
  )
}
